import IEmail from "../IEmail";

const InitialEmail: IEmail = {
    title: "",
    body: "",
    signatur: "",
};
export default InitialEmail;
